/* ============================================
   NIMBA FOODS — Klaviyo Email Subscribe Helper
   Uses Klaviyo Client Subscriptions API (public)
   ============================================ */

function nimbaIsLikelyValidEmail(email) {
  if (!email || typeof email !== 'string') return false;
  var normalized = email.trim().toLowerCase();
  var parts = normalized.split('@');
  var local = parts[0] || '';
  var domain = parts[1] || '';

  if (normalized.length > 254) return false;
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) return false;
  if (/^(test|example|yourname)(\+|@|$)/.test(local)) return false;
  if (/storebotmail|joonix|example\.com|test\.com/.test(domain)) return false;
  if ((local.match(/\./g) || []).length >= 4) return false;
  if (/^[a-z0-9]{10}$/.test(local) && /\d/.test(local) && /gmail\.com$/.test(domain)) return false;

  return true;
}

function klaviyoSubscribe(email, signupSource, properties) {
  if (!nimbaIsLikelyValidEmail(email)) return;
  email = email.trim().toLowerCase();
  const profileProperties = Object.assign(
    { signup_source: signupSource || 'website' },
    properties || {}
  );
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Ys2bwY', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: signupSource || 'website',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: profileProperties
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: 'RKYbsp' }
          }
        }
      }
    })
  }).catch(function () { /* fire-and-forget */ });
}
